export default __webpack_public_path__ + "static/media/icon.1813e5ae.svg";